import { api } from '~/application/api';
import type { CreateWarehouseZoneCommand, WarehouseZone, WarehouseZoneDetails } from '../types';

const zoneApi = api.enhanceEndpoints({
    addTagTypes: ['WarehouseZone', 'WarehouseZoneDetails'],
}).injectEndpoints({
    endpoints: build => ({
        createWarehouseZone: build.mutation<void, CreateWarehouseZoneCommand>({
            query: command => ({
                url: `/wms/zones`,
                method: 'POST',
                body: command,
            }),
            invalidatesTags: ['WarehouseZone'],
        }),
        listWarehouseZones: build.query<WarehouseZone[], void>({
            query: () => '/wms/zones',
            providesTags: result => result
                ? result.map(zone => ({ type: 'WarehouseZone', id: zone.id }))
                : ['WarehouseZone'],
        }),
        warehouseZoneDetails: build.query<WarehouseZoneDetails, string>({
            query: zoneId => `/wms/zones/${zoneId}`,
            providesTags: result => result
                ? [{ type: 'WarehouseZoneDetails', id: result.id }]
                : ['WarehouseZoneDetails'],
        }),
    }),
});

export const {
    useCreateWarehouseZoneMutation,
    useListWarehouseZonesQuery,
    useWarehouseZoneDetailsQuery,
} = zoneApi;
